"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerNotifications = void 0;
var React = __importStar(require("react"));
var customer_notifications_1 = require("@shared-ui/customer-notifications");
var mobx_react_1 = require("mobx-react");
var react_router_dom_1 = require("react-router-dom");
var CustomerNotifications = function (customerNotificationProps) {
    // Since this component expects its own `location` prop, using `withRouter` HOC causes prop collision
    var routeLocation = (0, react_router_dom_1.useLocation)();
    var CustomerNotificationsComponent = (0, mobx_react_1.inject)('page', 'context')(function (props) {
        var _a;
        var page = props.page, location = props.location, context = props.context, journeyCriterias = props.journeyCriterias;
        var pathLocation = (0, react_router_dom_1.useLocation)();
        React.useEffect(function () {
            document.documentElement.lang = context.locale.split('_')[0];
            // prevents browser from auto translating
            document.documentElement.translate = false;
        }, [pathLocation.pathname]);
        // don't show on landing since user isnt logged in yet
        // also don't show on error page
        if (!page || !page.pageId || pathLocation.pathname == '/' || pathLocation.pathname == '/error') {
            return null;
        }
        var referer = null;
        if (((_a = context === null || context === void 0 ? void 0 : context.site) === null || _a === void 0 ? void 0 : _a.domain) && routeLocation && routeLocation.search && routeLocation.pathname) {
            var domain = context.site.domain;
            var search = routeLocation.search, path = routeLocation.pathname;
            referer = "https://".concat(domain).concat(path).concat(search);
        }
        var optionalContext;
        if (journeyCriterias) {
            optionalContext = {
                referer: referer,
                journeyCriterias: journeyCriterias,
            };
        }
        else {
            optionalContext = {
                referer: referer,
            };
        }
        return (React.createElement("div", { className: "customer-notification-container" },
            React.createElement(customer_notifications_1.CustomerNotification, { inputs: {
                    xPageId: page.pageId,
                    notificationLocation: customer_notifications_1.CustomerNotificationLocation[location],
                    optionalContext: optionalContext,
                } })));
    });
    return React.createElement(CustomerNotificationsComponent, __assign({}, customerNotificationProps));
};
exports.CustomerNotifications = CustomerNotifications;
//# sourceMappingURL=customer-notifications.js.map